import { subDays } from "date-fns";

import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { typedQueryClient, useTypedQuery } from "hooks";
import { LeadsQueryKeys } from "modules/LeadsDashboard/queryKeys";
import { LEADS_CARS_STORAGE_KEYS } from "modules/LeadsDashboard/storageKeys";
import { PAGE_SIZE, getPreference, useUpdateLocationPreference } from "utils/common";
import { toDate } from "utils/dateHelperFunctions";

import type { DealerLocation } from "models";
import type { LeadsCarsFilter } from "modules/LeadsDashboard/queryKeys";

export const getDefaultLeadsCarsFilters = (selectedLocation?: DealerLocation | null): LeadsCarsFilter => ({
  page: 1,
  dealer_ids: getPreference(LEADS_CARS_STORAGE_KEYS.DealerPreference, []),
  search_term: "",
  is_lease_company: getPreference(LEADS_CARS_STORAGE_KEYS.LeaseCompanyPreference, null),
  date_from: getPreference(LEADS_CARS_STORAGE_KEYS.DateFromPreference, subDays(new Date(), 30)),
  date_to: getPreference(LEADS_CARS_STORAGE_KEYS.DateToPreference, toDate(new Date())),
  location_ids: getPreference(LEADS_CARS_STORAGE_KEYS.LocationPreference, selectedLocation?.id ? [selectedLocation.id] : []),
  page_size: getPreference(LEADS_CARS_STORAGE_KEYS.PageSizePreference, PAGE_SIZE.PageSize25)
});

export const useLeadsCarsFilters = () => {
  const { selectedLocation } = useSelectedLocation();
  useUpdateLocationPreference(LEADS_CARS_STORAGE_KEYS.LocationPreference, selectedLocation);

  return useTypedQuery({ queryKey: LeadsQueryKeys.carsFilters, initialData: getDefaultLeadsCarsFilters(selectedLocation) }).data;
};

export const setLeadsCarsFilters = (newFilters: LeadsCarsFilter) => {
  const filters = typedQueryClient.getQueryData(LeadsQueryKeys.carsFilters);
  if (!filters) return;
  typedQueryClient.setQueryData(LeadsQueryKeys.carsFilters, { ...filters, ...newFilters });
};
